import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import Logo from "./Logo";

// Signature on-load moment — dark overlay, logo scales in, counter ticks 00 → 100,
// then curtain lifts to reveal the hero.
export default function LoaderIntro({ onDone }) {
  const [count, setCount] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const start = performance.now();
    const total = 1600;
    let raf;
    const tick = (now) => {
      const p = Math.min(1, (now - start) / total);
      setCount(Math.floor(p * 100));
      if (p < 1) raf = requestAnimationFrame(tick);
      else {
        setTimeout(() => {
          setVisible(false);
          setTimeout(() => onDone?.(), 900);
        }, 250);
      }
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [onDone]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="loader-overlay grain"
          initial={{ opacity: 1 }}
          exit={{ opacity: 1 }}
        >
          <motion.div
            className="absolute inset-x-0 top-0 h-1/2 bg-obsidian z-10"
            exit={{ y: "-100%" }}
            transition={{ duration: 0.9, ease: [0.77, 0, 0.175, 1] }}
          />
          <motion.div
            className="absolute inset-x-0 bottom-0 h-1/2 bg-obsidian z-10"
            exit={{ y: "100%" }}
            transition={{ duration: 0.9, ease: [0.77, 0, 0.175, 1] }}
          />
          <div className="relative z-20 flex flex-col items-center gap-8">
            <motion.div
              initial={{ scale: 0.6, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            >
              <Logo variant="light" size={64} />
            </motion.div>
            <div className="flex items-baseline gap-6">
              <span className="font-mono-kl text-[10px] tracking-[0.3em] uppercase text-editorial/60">Est. 2019 · Bhubaneswar</span>
            </div>
            <div className="flex items-baseline gap-3">
              <span className="font-serif-display text-editorial text-[64px] leading-none tabular-nums">{String(count).padStart(3, "0")}</span>
              <span className="font-mono-kl text-editorial/50 text-xs">%</span>
            </div>
            <div className="w-56 h-px bg-editorial/20 overflow-hidden">
              <motion.div className="h-full bg-lime_kl" initial={{ width: 0 }} animate={{ width: `${count}%` }} />
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
